interface DescriptionTextProps {
  text: string
  maxHeight?: number
  showTruncation?: boolean
  className?: string
}

export function DescriptionText({
  text,
  maxHeight = 56,
  showTruncation = true,
  className = '',
}: DescriptionTextProps) {
  return (
    <div
      className={`text-sm font-normal text-gray-600 leading-relaxed ${className}`}
      style={{
        maxHeight: showTruncation ? `${maxHeight}px` : undefined,
        overflow: showTruncation ? 'hidden' : 'visible',
        display: showTruncation ? '-webkit-box' : 'block',
        WebkitLineClamp: showTruncation ? 4 : undefined,
        WebkitBoxOrient: showTruncation ? 'vertical' : undefined,
      }}
    >
      {text}
    </div>
  )
}
